import React from 'react'
import FBWhite from '../../../assets/codicons/fb-white.svg'
import IGWhite from '../../../assets/codicons/ig-white.svg'
import TwitWhite from '../../../assets/codicons/twit-white.svg'
import GlobeWhite from '../../../assets/codicons/globe-white.svg'
import Facebook from '../../../assets/codicons/facebook.svg'
import Instagram from '../../../assets/codicons/instagram.svg'
import Twitter from '../../../assets/codicons/twitter.svg'
import Globe from '../../../assets/codicons/globe.svg'

const SOCIAL_LINKS = [
  {
    key: 'facebook',
    field: 'fbLink',
    icon: <Facebook />,
    hoverIcon: <FBWhite />,
    className: 'facebook'
  },
  {
    key: 'instagram',
    field: 'igLink',
    icon: <Instagram />,
    hoverIcon: <IGWhite />,
    className: 'instagram'
  },
  {
    key: 'twitter',
    field: 'twLink',
    icon: <Twitter />,
    hoverIcon: <TwitWhite />,
    className: 'twitter'
  },
  {
    key: 'website',
    field: 'website',
    icon: <Globe />,
    hoverIcon: <GlobeWhite />,
    className: 'coach-web'
  }
]

const isValidUrl = (url) => {
  if (!url) return false
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

const CoachHeader = ({ coachInfo }) => {
  return (
    <div
      className='profile-cover header-cover-container'
      data-page-cover=''
      style={{ backgroundImage: `url(${coachInfo.bannerPhoto})` }}
    >
      <div className='overlay' />
      <div className='header-content-container' data-page-cover-padding=''>
        <div className='header-content'>
          <div className='profile-name-container'>
            <h1 className='profile-name'>{coachInfo.name}</h1>

            <ul className='social'>
              {SOCIAL_LINKS.map(
                ({ key, field, icon, hoverIcon, className }) => {
                  const url = coachInfo[field]
                  if (!isValidUrl(url)) return null

                  return (
                    <li key={key} className={className}>
                      <a
                        href={url}
                        className='social-icon'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        {icon}
                        {hoverIcon}
                      </a>
                    </li>
                  )
                }
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoachHeader
